<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="180px" :rules="rules" :model="formData">
					<el-form-item label="原缴费开始日期">
						<el-date-picker
							size="small"
							style="width: 250px"
							v-model="formData.startTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
							type="date"
							placeholder="选择原缴费开始日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="原缴费结束日期" prop="nextStartTime">
						<el-date-picker
							size="small"
							style="width: 250px"
							v-model="formData.nextStartTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
							type="date"
							placeholder="选择原缴费结束日期"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "ModifyRenewalDateForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				// startTime: [{ required: true, message: "请选择原缴费开始日期", trigger: "blur" }],
                nextStartTime: [{ required: true, message: "请选择新缴费开始日期", trigger: "blur" }]
			},
		};
	},
	methods: {
		doSave() {
            const url = '/car/web/carManage/card/renewDate';
            this._doSaveForm(this.$refs.form, url, 'POST');
		},
	},
};
</script>
